import axios from 'axios';
import { API } from './apiConfig';

const authHeader = () => ({ withCredentials: true });

export const fetchContentProtection = async () => {
  const { data } = await axios.get(`${API}/content-protection`);
  return data;
};

export const saveContentProtection = async (enabled, whitelist) => {
  const { data } = await axios.post(`${API}/admin/content-protection`, { enabled, whitelist }, authHeader());
  return data;
};
